import type { InferResponseType } from 'hono/client';
import { ensureResponseOk } from '../../../shared/errors/HttpError';
import type { ApiClient } from '../../auth/api/clients';

// guardedFetch はリフレッシュ失敗後の 401 をレスポンスとして返すため、
// 各関数で ensureResponseOk により HttpError へ統一する。

export type WorkHistoryUploadTarget = InferResponseType<ApiClient['g-staff-records']['upload-url']['$post']>;
export type WorkHistoryPreview = InferResponseType<ApiClient['g-staff-records']['validation']['$post']>;
export type WorkHistoryRowError = WorkHistoryPreview['errorRows'][number];
export type WorkHistoryUploadResult = InferResponseType<ApiClient['g-staff-records']['$put']>;

/** 稼働歴ファイルを S3 へ直接 PUT するための presigned URL とステージングキーを発行する */
export const createWorkHistoryUploadUrl = async (apiClient: ApiClient): Promise<WorkHistoryUploadTarget> => {
  const res = await apiClient['g-staff-records']['upload-url'].$post();
  await ensureResponseOk(res);
  return await res.json();
};

/**
 * 稼働歴ファイルを presigned URL で S3 へ直接 PUT する。
 * 認証は URL の署名で行われるため、認証ヘッダー・Cookie は付けない
 */
export const putWorkHistoryFileToS3 = async (url: string, file: File): Promise<void> => {
  const res = await fetch(url, { method: 'PUT', body: file });
  await ensureResponseOk(res);
};

/** ステージング済みの稼働歴ファイルをサーバーで変換・検証し、反映せずにプレビュー（取込件数・エラー行）を取得する */
export const validateWorkHistoryFile = async (apiClient: ApiClient, key: string): Promise<WorkHistoryPreview> => {
  const res = await apiClient['g-staff-records'].validation.$post({ json: { key } });
  await ensureResponseOk(res);
  return await res.json();
};

/** ステージング済みの稼働歴ファイルをサーバーで変換し、Gスタッフ稼働歴を新しい内容で置き換える */
export const uploadWorkHistoryFile = async (apiClient: ApiClient, key: string): Promise<WorkHistoryUploadResult> => {
  const res = await apiClient['g-staff-records'].$put({ json: { key } });
  await ensureResponseOk(res);
  return await res.json();
};
